module.exports = __webpack_public_path__ + "static/media/296041.1580d024.png";